// extracted by mini-css-extract-plugin
export default {"name":"GroupItem-modules__name__b1CAR","courses":"GroupItem-modules__courses__VdKah","show-keyframe":"GroupItem-modules__show-keyframe__t4lz6"};